export function removeSeconds(time: string): string {
  if (!time) return "12:00";
  const parts = time.split(":");
  return `${parts[0]}:${parts[1] || "00"}`;
}

export function mapActionIdToName(
  id?: number | null,
  options: { id: number; name: string }[] = []
): string {
  const match = options.find((option) => option.id === id);
  return match?.name ?? "Auto";
}
